import client from "./client";

const getSettlementGroups = () => client.get("/settlement/group/view");

export default { getSettlementGroups };
